export enum ProviderSystem {
    ABRAFB = 'ABRA-FB',
    CUSTOM = 'CUSTOM',
    SHOPIFY = 'SHOPIFY',
    SHOPTET = 'SHOPTET',
    WOOCOMMERCE = 'WOOCOMMERCE',
    KILPI = 'KILPI',
    NAREX = 'NAREX'
}
